/* Source: source-gift.html, source variant 43440891625562.
 * Price is native $0; no coupon or price override. Only mapped destination ID. */
(() => {
  if (window.pnGift) return;
  if (document.querySelector('[data-nibosi-bogo-page]')) return;
  const giftId = 52880875094245;
  const rawFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  let busy = false, pending = false, timer, selected = true, initialized = false;
  let offerOperations = 0, preserveOfferCart = false;
  const controls = () => [...document.querySelectorAll('[id="an-gift-toggle"]')];
  function display() {
    controls().forEach(input => {
      input.disabled = busy || offerOperations > 0;
      input.removeAttribute('aria-disabled');
      input.checked = selected;
      input.setAttribute('aria-busy', String(busy || offerOperations > 0));
    });
  }
  function error(message) {
    document.querySelectorAll('.an-gift').forEach(box => {
      let el = box.querySelector('[data-pn-gift-error]');
      if (!el) { el = document.createElement('p'); el.dataset.pnGiftError = ''; el.setAttribute('role', 'status'); box.append(el); }
      el.textContent = message;
    });
  }
  async function request(route, data) {
    const message = 'Gift could not be updated. Please try again.';
    try {
      const response = await rawFetch(root + route, data ? {
        method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)
      } : {});
      // Shopify Ajax endpoints can return JSON with Content-Type: text/javascript.
      // Parse the payload itself; HTML and malformed JSON still fail safely below.
      if (!response.ok) throw new Error(message);
      const result = await response.json();
      if (!result || typeof result !== 'object' || Array.isArray(result)) throw new Error(message);
      return result;
    } catch (_) { throw new Error(message); }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 200); }
  // Dynamic quick-add can mount after this controller has initialized on a collection.
  // Hold reconciliation for the complete offer transaction, not for a DOM marker's lifetime.
  function beginOffer() {
    offerOperations += 1;
    clearTimeout(timer);
    display();
    let finished = false;
    return ({ attempted = false } = {}) => {
      if (finished) return;
      finished = true;
      preserveOfferCart = preserveOfferCart || attempted;
      offerOperations -= 1;
      display();
      schedule();
    };
  }
  function offerOwnsGiftChoice(cart) {
    if (!offerOperations && preserveOfferCart && cart.items.length === 0) {
      preserveOfferCart = false;
      initialized = false;
    }
    if (!offerOperations && !preserveOfferCart) return false;
    // Existing gifts are customer state: never add or remove them for an offer.
    selected = cart.items.some(item => item.variant_id === giftId);
    initialized = true;
    error('');
    return true;
  }
  async function sync() {
    if (busy) { pending = true; return; }
    busy = true; display();
    try {
      await window.pnCartTransactions.run(async () => {
      const cart = await request('cart.js');
      if (offerOwnsGiftChoice(cart)) return;
      const gifts = cart.items.filter(item => item.variant_id === giftId);
      const hasProduct = cart.items.some(item => item.variant_id !== giftId);
      if (!initialized) {
        selected = !(hasProduct && !gifts.length);
        initialized = true;
      }
      let result;
      const sections = ['cart-drawer', 'cart-icon-bubble'];
      if ((!hasProduct || !selected) && gifts.length) {
        result = await request('cart/update.js', {updates: Object.fromEntries(gifts.map(item => [item.key, 0])), sections, sections_url: location.pathname});
      } else if (hasProduct && selected && !gifts.length) {
        // Recheck price from Shopify before adding; never silently charge for a "free" gift.
        const product = await request('products/silver-bracelet.js');
        // The offer may have started while the legacy availability request was pending.
        if (offerOwnsGiftChoice(cart)) return;
        const variant = product.variants.find(item => item.id === giftId);
        if (!variant?.available || variant.price !== 0) throw new Error('Complimentary gift is currently unavailable.');
        result = await request('cart/add.js', {items: [{id: giftId, quantity: 1}], sections, sections_url: location.pathname});
      }
      if (result) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.renderContents) {
          result.pnRevision = window.pnCartTransactions.revision;
          drawer.renderContents(result, !drawer.classList.contains('active'));
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'pn-gift'});
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      error('');
      });
    } catch (e) { error(e.message); }
    finally { busy = false; display(); if (pending) { pending = false; schedule(); } }
  }
  // Observe successful native cart requests; our own requests use rawFetch to prevent recursion.
  window.fetch = async function(input, init) {
    const response = await rawFetch(input, init);
    let url;
    try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href); } catch { return response; }
    if (url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname) && response.ok) schedule();
    return response;
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[id="an-gift-toggle"]')) {
      if (offerOperations) { display(); return; }
      // A deliberate gift choice outside an active offer remains authoritative.
      preserveOfferCart = false;
      initialized = true; selected = event.target.checked; display(); schedule();
    }
  });
  document.addEventListener('shopify:section:load', display);
  document.addEventListener('pn:quick-add:loaded', display);
  new MutationObserver(display).observe(document.documentElement, {childList: true, subtree: true});
  window.pnGift = {sync, beginOffer};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
